import React, { Component } from 'react';
import {
  Modal,
  Input,
  Button,
  List,
  Card,
  Row,
  Col,
  Typography,
  Checkbox,
  Tag,
} from 'antd';
import Select from 'react-select';
import { withRouter } from 'react-router-dom';
import { getSpecialistSuggestions } from '../../services/api/suggestions';
const { Text } = Typography;

class SuggestionsDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      disableSubmit: false,
      selectedVertical: null,
      visitOnly: 0,
      latitude: null,
      longitude: null,
      radius: 5,
      collapse: false,
      suggestions: [],
      requestId: '',
      hits: 0,
      time: 0,
      limit: 10,
    };
  }

  validateSuggestionsPayload = () => {
    let result = '';
    if (!this.state.latitude) {
      result += ' Latitude';
    }
    if (!this.state.longitude) {
      result += ' Longitude';
    }
    if (!this.state.selectedVertical) {
      result += ' Speciality';
    }
    if (result.length > 0) {
      return result;
    }
    return false;
  };

  showSuggestions = () => {
    console.log(this.state, 'Current State');
    // validate
    const result = this.validateSuggestionsPayload();
    if (result) {
      alert(`Complete all details: ${result}`);
      return;
    }
    // disable submit button
    this.setState({
      disableSubmit: true,
      collapse: false,
    });
    let filters;
    // speciality clause
    filters = `v=${this.state.selectedVertical.value}&lat=${
      this.state.latitude
    }&lng=${this.state.longitude}&o=${this.state.visitOnly ? 1 : 0}&r=${
      this.state.radius
    }&l=${this.state.limit}`;
    getSpecialistSuggestions(filters)
      .then(data => {
        console.log(data, 'Suggestions');
        // checking for suggestions
        if (data.body.message === 'success') {
          // enabling submit button
          this.setState({
            collapse: true,
            disableSubmit: false,
            suggestions: data.body.results,
            hits: data.body.hits,
            time: data.body.time,
          });
          return;
        }
        alert('Something went wrong');
      })
      .catch(err => {
        console.log(err, 'Fetch Communications');
      });
  };

  componentDidMount() {
    const requestDetails = this.props.suggestionsDetails;
    if (requestDetails) {
      console.log(this.props.suggestionsDetails, 'Details when mounting');
      const verticals = this.props.verticals;
      let defVer = null;
      verticals.forEach(v => {
        if (v.id === requestDetails.verticalId) {
          defVer = {
            value: v.id,
            label: v.name,
          };
        }
      });
      this.setState({
        selectedVertical: defVer,
        latitude: requestDetails.latitude,
        longitude: requestDetails.longitude,
        requestId: requestDetails.consultationId,
      });
    }
  }

  toggleParentModal = () => {
    // reset the message checks
    this.setState({
      collapse: false,
      choice: 1,
    });
    // call the parent method
    this.props.closeSuggestions();
  };

  listAllVerticals = () => {
    console.log(this.props.verticals);
    const verticals = this.props.verticals;
    const options = [];
    if (verticals) {
      verticals.forEach(v => {
        options.push({
          value: v.id,
          label: v.name,
        });
      });
    }
    return options;
  };

  handleChange = selectedVertical => {
    this.setState({ selectedVertical });
    console.log(`Option selected:`, selectedVertical);
  };

  handleCheck = e => {
    this.setState({
      visitOnly: e.target.checked,
    });
  };

  handleLatitudeChange = e => {
    const { value } = e.target;
    this.setState({
      latitude: value,
    });
  };

  handleLongitudeChange = e => {
    const { value } = e.target;
    this.setState({
      longitude: value,
    });
  };

  handleChangeRadius = e => {
    const { value } = e.target;
    this.setState({
      radius: value,
    });
  };

  handleLimitChange = e => {
    const { value } = e.target;
    this.setState({
      limit: value,
    });
  };

  render() {
    return (
      <Modal
        visible={this.props.isOpen}
        onCancel={this.toggleParentModal}
        title={`Specialist Suggestions for Request ${this.state.requestId}`}
      >
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <Text level={4} for="forLatitude">
              Latitude
            </Text>
            <Input
              type="text"
              name="latitude"
              id="forLatitude"
              value={this.state.latitude}
              placeholder="28.55667"
              onChange={this.handleLatitudeChange}
            />
          </Col>
          <Col span={6}>
            <Text level={4} for="forLongitude">
              Longitude
            </Text>
            <Input
              type="text"
              name="longitude"
              id="forLongitude"
              value={this.state.longitude}
              placeholder="78.33225"
              onChange={this.handleLongitudeChange}
            />
          </Col>
          <Col span={12}>
            <Text level={4} for="selectVertical">
              Speciality
            </Text>
            <Select
              value={this.state.selectedVertical}
              onChange={this.handleChange}
              options={this.listAllVerticals()}
              id={'selectVertical'}
            />
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col span={6}>
            <Checkbox
              onChange={this.handleCheck}
              checked={this.state.visitOnly}
            >
              Visit Onboarded Only
            </Checkbox>
          </Col>
          <Col span={8}>
            <Text level={4} for="forLimit">
              No. of suggestions
            </Text>
            <Input
              type="text"
              name="limit"
              id="forLimit"
              value={this.state.limit}
              placeholder="10"
              onChange={this.handleLimitChange}
            />
          </Col>
          <Col span={8}>
            <Text level={4} for="forRadius">
              Radius(in km)
            </Text>
            <Input
              type="text"
              name="radius"
              id="forRadius"
              value={this.state.radius}
              onChange={this.handleChangeRadius}
            />
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Button
            type="primary"
            disabled={this.state.disableSubmit}
            onClick={this.showSuggestions}
          >
            Show Suggestions
          </Button>
        </Row>

        <br />

        <Row>
          <Col>
            {this.state.collapse && (
              <Col isOpen={this.state.collapse}>
                {this.state.hits} results found in {this.state.time} ms
                <Card>
                  <Col>
                    <List>
                      {this.state.suggestions.length === 0 ? (
                        <List.Item>No Suggestions found</List.Item>
                      ) : (
                        this.state.suggestions.map(m => {
                          return (
                            <List.Item>
                              <Col span={12}>
                                <b>{m.doctorName}</b>
                                <br />
                                {m.qualifications}
                                <br />
                                {m.centerName}
                                <br />
                                <Button
                                  type="link"
                                  onClick={() => {
                                    this.props.history.push(
                                      `/doctor-profile/${m.doctorId}`
                                    );
                                  }}
                                  target="_blank"
                                >
                                  {m.doctorId}
                                </Button>
                              </Col>
                              <Col span={12}>
                                <Tag color="grey" pill>
                                  {m.source}
                                </Tag>
                                <br />
                                <b>Charges:</b> Rs. {m.charges}
                                <br />
                                <b>Discount:</b> {m.discount} %
                                <br />
                                <b>Experience:</b> {m.experience} years
                                <br />
                                <b>Distance: </b> {m.distance} km
                              </Col>
                            </List.Item>
                          );
                        })
                      )}
                    </List>
                  </Col>
                </Card>
              </Col>
            )}
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default withRouter(SuggestionsDialog);
